import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useContext } from 'react';
import Button from '../../../common/base/Button';
import Divider from '../../../common/base/Divider';
import Text from '../../../common/base/Text';
import { Div } from '../../../common/helpers/StyledUtils';
import Modal from '../../../common/Modal';
import { useToasts } from '../../../common/Toast';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { getCreateTenantInitialValues, submitCreateTenantForm, TenantCreateFields, TenantFormValues } from '../utils/outpostForms';
import Alert from '../../../common/base/Alert';
interface CreateTenantModalProps {
  existing_tenant_ids: string[];
  mutateTenants: () => void;
  onClose: () => void;
}
const CreateTenantModal: React.FC<CreateTenantModalProps> = t0 => {
  const $ = _c(16);
  const {
    mutateTenants,
    onClose
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    addToast
  } = useToasts();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getCreateTenantInitialValues();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== addToast || $[2] !== mutateTenants || $[3] !== onClose) {
    t2 = async () => {
      mutateTenants();
      addToast("success", "Tenant created");
      onClose();
    };
    $[1] = addToast;
    $[2] = mutateTenants;
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== addToast) {
    t3 = error_message => {
      addToast("error", `Failed to create tenant${error_message ? `: ${error_message}` : ""}`);
    };
    $[5] = addToast;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== HookdeckAPI || $[8] !== t2 || $[9] !== t3) {
    t4 = submitCreateTenantForm({
      HookdeckAPI,
      on_success: t2,
      on_error: t3
    });
    $[7] = HookdeckAPI;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== onClose) {
    t5 = props => <Form onSubmit={props.handleSubmit}><Modal title="Add new tenant" is_submitting={props.isSubmitting} onClose={onClose}><Text muted={true} m={{
          b: 3
        }}>{"Each tenant is an entity in your product that owns destinations and events, typically an org or team (or one user in a smaller app). It can have multiple destinations where published events are delivered."}</Text><TenantCreateFields focus={true} /><Alert inline={true} m={{
          t: 4
        }}>Hint: Add a <code>name</code> key to your tenant metadata to display a friendly name.</Alert><Div m={{
          x: -4,
          t: 4,
          b: 3
        }}><Divider /></Div><Div flex={{
          align: "center",
          justify: "flex-end",
          gap: 3
        }} m={{
          b: -1
        }}><Button type="button" onClick={onClose} outline={true}>Cancel</Button><Button icon="save" disabled={props.isSubmitting || !props.isValid || !props.dirty} type="submit" onClick={() => props.handleSubmit()} primary={true}>Create tenant</Button></Div></Modal></Form>;
    $[11] = onClose;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <Formik initialValues={t1} onSubmit={t4}>{t5}</Formik>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default CreateTenantModal;